import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { fuseAnimations } from '../../../../../../core/animations';

/** Service file */
import { AssignProService } from '../assignPro.service';
import { SolutionFormService } from '../../solutionForm/solutionForm.service';

/**  Local file*/
import { assignPro, spekwo, orders } from '../../../utils/index';
import { CommonOrdersService } from '../../orders/commonOrders.service';

@Component({
    selector: 'after-assigned',
    templateUrl: './afterAssigned.component.html',
    styleUrls: ['./afterAssigned.component.scss'],
    animations: fuseAnimations,
    encapsulation: ViewEncapsulation.None,
})
export class AfterAssignedComponent {

    orderIdSubscription: Subscription;
    proDetails: any;
    orderDetail: any;
    spekwoValues: any;
    assignPro: any;
    ordersValues: any;
    allStatus: OrderStatus[];
    afterLoading: boolean = false;

    constructor(
        public assignProService: AssignProService,
        public solutionFormService: SolutionFormService,
        public commonOrdersService: CommonOrdersService,
    ) {
        this.spekwoValues = spekwo;
        this.assignPro = assignPro;
        this.ordersValues = orders;
    }
    ngOnInit() {
        this.commonOrdersService.listOfStatus.subscribe((statusRes) => {
            this.allStatus = statusRes.length > 0 ? statusRes : [];
        });

        this.proDetails = {};
        this.orderDetail={};
        this.afterLoading = true;

        this.orderIdSubscription =
            this.assignProService.orderStatus.subscribe(response => {

                if (response.loading) {
                    this.afterLoading = true;

                } else {

                    this.orderDetail = response.details;
                 
                    if (response.details && response.details.acceptedBy) {
                       
                        this.solutionFormService.GetUserNameById(response.details.acceptedBy)
                            .then((user: any) => {
                               
                                if (user.length > 0) {
                                    user.map(userData => {
                                        this.proDetails = userData.node;
                                    })
                                }

                            })
                            .catch(error => {
                                console.log('GetUserNameByIdError', error);
                            })
                    }

                    this.afterLoading = false;
                }


            })
        this.afterLoading = false;
    }

    ngOnDestroy() {
        this.orderIdSubscription.unsubscribe();
    }

    setDefaultPic(event, profilePic) {
        event.target.src = profilePic === 'yes' ? this.spekwoValues.defaultImg : this.spekwoValues.defaultLogo;
    }

    assignAnotherPro() {      
        this.assignProService.assignAnotherProChanged.next(null);
    }


}
export interface OrderStatus {
    statusId: number;
    statusName: string;
    displayStatus: string;
}
  


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/assignPro/after-assigned/afterAssigned.component.ts